/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import i18n from 'i18next';
import en from './locales/en.json';
import ru from './locales/ru.json';
import az from './locales/az.json';
import { initReactI18next } from 'react-i18next';

export enum LocaleId {
    En = 'en',
    Ru = 'ru',
    Az = 'az',
}

const ns = 'locales';

i18n.use(initReactI18next).init({
    // https://www.i18next.com/overview/configuration-options
    interpolation: { escapeValue: false },
    lng: 'en',
    // debug: true,
    ns,
    defaultNS: ns,
    returnEmptyString: false,
    resources: {
        en: { [ns]: en },
        ru: { [ns]: ru },
        az: { [ns]: az },
    },
    parseMissingKeyHandler: (missingKey) => {
        console.warn(`i18n: missing key: "${missingKey}"`);
        return missingKey;
    },
});

export { i18n };
export const _ = (str: string) => str;

export function toLocaleString(value: number): string {
    return value && value.toLocaleString(i18n.language);
}
